// extracted by mini-css-extract-plugin
export default {"study_content":"study_study_content__IsL7t"};